/**
 * PlaceholderPage Component
 * Coming Soon page with consistent styling for unimplemented routes
 */

import React from 'react';
import { Rocket } from 'lucide-react';
import styles from './PlaceholderPage.module.css';

export interface PlaceholderPageProps {
  /** Page title */
  title: string;
  /** Optional description */
  description?: string;
}

export const PlaceholderPage: React.FC<PlaceholderPageProps> = ({
  title,
  description,
}) => {
  return (
    <div className={styles.placeholderPage}>
      <div className={styles.content}>
        <div className={styles.iconWrapper}>
          <Rocket size={64} className={styles.icon} />
        </div>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.subtitle}>Coming Soon</p>
        {description && <p className={styles.description}>{description}</p>}
      </div>
    </div>
  );
};

export default PlaceholderPage;
